import { CommonFormFields } from "commons/Forms/formsComponents/formTypes";
import Moment from 'moment';
import ServiceAirTree from "services/airTree";
import { disabledDateInRange, FormatDate } from "utils/helpers/date_helpers";

export const AirTreeProjectFormFields = ({ simulationDateRange = null }): CommonFormFields[] => {
    return [
        {
            name: 'name',
            label: 'Nome progetto',
            type: 'string',
            required: true,
            span: 12
        },
        {
            type: 'select',
            label: 'Tipo di suolo',
            name: 'soil_texture',
            span: 12,
            options: [
                { label: 'Sabbioso', value: 1 },
                { label: 'Limoso', value: 2 },
                { label: 'Argilloso', value: 3 },
                { label: 'Altro', value: 4 },
            ],
        },
        {
            picker: 'month',
            type: 'date',
            name: 'simulation_date_start',
            label: 'Data inizio simulazione (range compreso negli ultimi 3 anni)',
            format: 'MM/YYYY',
            required: true,
            disabledDate: (current) => {
                console.log('SIMMMM', simulationDateRange)
                if (simulationDateRange?.simulationDateStart && simulationDateRange?.simulationDateEnd) {
                    return disabledDateInRange(current, Moment(simulationDateRange?.simulationDateStart), Moment(simulationDateRange?.simulationDateEnd))
                } else {
                    return disabledDateInRange(current, Moment().subtract(3, 'years'), Moment().subtract(2, 'months'))
                }
            },
            span: 12
        },
        {
            picker: 'month',
            type: 'date',
            name: 'simulation_date_end',
            label: 'Data fine simulazione',
            format: 'MM/YYYY',
            required: true,
            disabledDate: (current) => {
                if (simulationDateRange?.simulationDateStart && simulationDateRange?.simulationDateEnd) {
                    return disabledDateInRange(current, Moment(simulationDateRange?.simulationDateStart), Moment(simulationDateRange?.simulationDateEnd))
                } else {
                    return disabledDateInRange(current, Moment().subtract(3, 'years'), Moment().subtract(2, 'months'))
                }
            },
            span: 12
        },
        {
            type: 'radio',
            label: 'Irrigazione',
            name: 'irrigation',
            showAsButtons: true,
            options: [
                { label: 'Si', value: true },
                { label: 'No', value: false },
            ],
            span: 24
        },
        {
            type: 'radio',
            label: 'Tipologia progetto',
            name: 'type',
            showAsButtons: true,
            options: [
                { label: 'Pubblico', value: 1 },
                { label: 'Privato', value: 2 },
            ],
            span: 24
        },
        {
            name: 'note',
            label: 'Note',
            type: 'textarea',
        },
    ]
};